export default __webpack_public_path__ + "static/media/ContactHeader.c1d1cc6d.jpg";